export enum UserCreationOriginId {
  SelfRegistration = 'SelfRegistration',
  AdminPanelRegistration = 'AdminPanelRegistration',
  DaemonRegistration = 'DaemonRegistration',
  EditorCollaboratorRegistration = 'EditorCollaboratorRegistration',
  SingleAppViewCollaboratorRegistration = 'SingleAppViewCollaboratorRegistration',
}
